'use strict';exports.__esModule = true;var advancedFiltersSearchRequest = function advancedFiltersSearchRequest(routeParams, fields) {
  var fieldKeys = Object.keys(fields);
  var params = {};
  var nestedFields = [];

  for (var _iterator = fieldKeys, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {var _ref;if (_isArray) {if (_i >= _iterator.length) break;_ref = _iterator[_i++];} else {_i = _iterator.next();if (_i.done) break;_ref = _i.value;}var field = _ref;
    if (fields[field] && Object.keys(fields[field]).length && field !== 'commodities' && field !== 'toilets' && field !== 'bathrooms') {
      nestedFields.push(field);
    } else {
      params[field] = fields[field];
    }
  }

  nestedFields.forEach(function (field) {
    var nestedKeys = Object.keys(fields[field]);
    if (field !== 'price') {
      params[field] = {};
      nestedKeys.forEach(function (key) {
        if (fields[field][key] && fields[field][key].length && +fields[field][key] >= 0) {
          params[field][key] = fields[field][key];
        }
      });
    }
  });

  return Object.assign({},
  routeParams, {
    params: Object.assign({},
    routeParams.params,
    params) });


};exports.default =

advancedFiltersSearchRequest;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/advancedFiltersSearchRequest.js
// module id = 1239
// module chunks = 0